import React, { useState, ChangeEvent } from "react";
import { Box, Typography, Stack } from "@mui/material";
import { BlockModalWrapper } from "../../../components/block-modal-wrapper/block-modal-wrapper";
import useAppStore from "../../../stores/appStore";
import { AvatarWithCircle } from "../../../components/user-menu-trigger/user-avatar/avatar-with-circle";
import useUserStore from "../../../stores/userStore";
import {
  resizeImageFile,
  convertHeicFile,
} from "../../../helpers/resizeImageFile";
import { ButtonOutlined } from "../../../components/button-outlined/button-outlined";
import { avatarImageStyles } from "./styles";

export const SettingsAvatarUser: React.FC = () => {
  const { userAvatar, uploadUserAvatar } = useAppStore();
  const { user } = useUserStore();
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [uploading, setUploading] = useState<boolean>(false);

  const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      let file = e.target.files[0];
      const preview = URL.createObjectURL(file);
      setPreviewUrl(preview);

      setUploading(true);
      try {
        if (file.name.toLowerCase().endsWith(".heic")) {
          file = await convertHeicFile(file);
        }
        const resizedFile = await resizeImageFile(file, 600, 600, 0.6);
        await uploadUserAvatar(resizedFile);
        setPreviewUrl(null);
      } catch (error) {
        console.error("Error uploading avatar:", error);
      } finally {
        setUploading(false);
      }
    }
  };

  return (
    <BlockModalWrapper lable="Change Avatar" isColumn>
      <Stack spacing={3} alignItems="center" sx={{ mt: 2 }}>
        <Box>
          {previewUrl ? (
            <Box
              component="img"
              src={previewUrl}
              alt="Selected Avatar"
              sx={avatarImageStyles}
            />
          ) : (
            <AvatarWithCircle
              size="120px"
              img={userAvatar}
              // sx={userAvatarStyles}
              userId={user.id}
            />
          )}
        </Box>
        <Box>
          <ButtonOutlined component="label" variant="outlined">
            {uploading ? "Uploading..." : "Choose File"}
            <input
              hidden
              accept="image/*"
              type="file"
              onChange={handleFileChange}
            />
          </ButtonOutlined>
        </Box>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Your current avatar is shown above. Choose a new file to update.
        </Typography>
      </Stack>
    </BlockModalWrapper>
  );
};
